<template>
    <div>
        <NavigateBar style="background: #f6f6f6;" :title="'绑定微信'" @handleBack="goOff"/>
        <div v-if="bind_wechat" class="layout">
            <div class="layout_tx">
                <img :src="wechat_header" alt="">
                <div>{{ wechat_nick }}</div>
                <div class="layout_hb">
                    当前账户已绑定微信，<button class="layout_butt" type="text" @click="changebinding">我要换绑</button>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="!Weixin" style="text-align: center;">
                <div style="text-align: center;margin-top: 40px;">当前账户未绑定微信，微信扫码绑定</div>
                <div class="larweima" id="erweimt" ref="erweimt"></div>
                <van-button style="margin-top: 20px;" type="info" size="small" @click="download">保存二维码</van-button>
            </div>
            <div v-else>
                <div style="margin-left: 38px;">
                    <p class="qinbdwx">请绑定微信</p>
                    <p class="weixinjs">为了让您更好的体验，请您绑定微信账号</p>
                </div>
                <div class="weixinhz">
                    <img class="weixintx" src="../../assets/images/weixinbd.png" alt="">
                    <img class="weixinbdan" @click="getLoginCode(2)" src="../../assets/images/weixinbdan.png" alt="">
                </div>
                <!-- <van-button style="margin-top: 40px;" type="info" size="small" @click="getLoginCode(2)">点击按钮微信授权绑定</van-button> -->
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { Toast, Dialog } from 'vant';
    import NavigateBar from "../myHomework/navigateBar.vue";
    import QRCode from 'qrcodejs2'
    import { useOrgConfig } from '@/utils/useUserConfig.js';
    import { mapGetters } from 'vuex';
    Vue.use(Dialog);
    export default {
      name: 'BindWeChat',
      computed: {
          ...mapGetters({
            org_id: 'user/getOrgId'
          }),
      },
      data () {
        return {
            loginTimer: null,
            bind_wechat: false,
            wechat_header: '',
            wechat_nick: '',
            Weixin: false,
            qqqrcodema: '',
            myOrgConfig: {}
        }
      },
       components: {
        NavigateBar,
      },
      async created() {
        this.myOrgConfig = await useOrgConfig()
        this.isWeixin()
        this.getUserInfo();
        if (this.getQueryString("code")) {
            this.getFansInfo()
        }
    },
      methods: {
        getFansInfo() {
            let loginUrl = `/liveapi/api/user/login/autoLogin?code=${this.getQueryString("code")}&uid=${this.org_id}&appid=${this.myOrgConfig.official_account_appid}&flag=1`
            this.$liveApi.post(loginUrl,{timeout: 2000})
            .then((data)=> {
                console.log('data==333', data.data.data.fans_id)
                this.bindWechat(data.data.data.fans_id)
            })
        },
        getQueryString(name) {
            console.log('进入');
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        download() {
            const img = this.$refs.erweimt.querySelector('img'); // 获取生成的二维码图片元素
            if (img) {
                const canvas = document.createElement('canvas'); // 创建一个canvas元素
                const ctx = canvas.getContext('2d'); // 获取canvas的上下文
                canvas.width = img.width; // 设置canvas的宽度和高度与图片相同
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0); // 将图片绘制到canvas上
                const url = canvas.toDataURL('image/png'); // 将canvas转换为图片URL
                const link = document.createElement('a'); // 创建一个a标签用于下载图片
                link.download = '授权二维码.png'; // 设置下载文件名
                link.href = url; // 设置a标签的href属性为图片的URL
                link.click(); // 模拟点击下载图片
            } else {
                alert('QR code not found!'); // 如果找不到图片，则提示用户
            }
        },
        isWeixin() {
            var agent = navigator.userAgent.toLowerCase();
            if (agent.match(/MicroMessenger/i) == "micromessenger") {
                this.Weixin = true;
            } else {
                this.Weixin = false;
            }
        },
        changebinding() {
            Dialog.confirm({
                title: '换绑',
                message: '确定要换绑微信吗？',
            })
            .then(() => {
                this.bind_wechat = false
                this.getLoginCode(1)
            })
            .catch(() => {
                // on cancel
            });
        },
        getLoginCode(int) {
            this.$liveApi.get(`/liveapi/wap/login/getLoginCode`, { timeout: 5000 })
            .then((res2) => {
            if (res2.data.code == 200) {
                this.qqqrcodema = res2.data.data.code;
                console.log('21231===', this.qqqrcodema, this.myOrgConfig)
                this.showQrcode(this.qqqrcodema, this.myOrgConfig, int);
                if (!this.Weixin) {
                    this.loginTimer = setInterval( () => {
                        this.checkCodeStatus(this.qqqrcodema)
                    }, 3000);
                }
            }
            })
        },
        checkCodeStatus(qqqrcodema) {
            this.$liveApi.post(`/liveapi/wap/login/checkCodeStatus`, {code:qqqrcodema})
                .then( res => {
                  if (res.data.code == 200) {
                    if (res.data.data.status == 3) {
                      clearInterval(this.loginTimer);
                      this.loginTimer = null;
                      this.userInfo = res.data.data.fans_data;
                      this.bindWechat(this.userInfo.fans_id)
                      console.log('userInfo===', this.userInfo )
                    }
                  }
                });
        },
        showQrcode(qqqrcodema, myOrgConfig, int) {
            if(this.Weixin) {
                const fullUrl = encodeURIComponent(window.location.href);
                this.contractUrl = `${myOrgConfig.wechat_auth_domain}/login/#/wx-login?appId=${myOrgConfig.official_account_appid}&uId=${this.org_id}&redirectUrl=${fullUrl}&title=授权登录&origin=shanhu`
                // this.contractUrl = `${myOrgConfig.wechat_auth_domain}/login/#/wx-pc-login?qrcode=${qqqrcodema}&appId=${myOrgConfig.official_account_appid}&uId=${this.org_id}&wxfans_id=${myOrgConfig.fans_id}&origin=shanhu`
            } else {
                this.contractUrl = `${myOrgConfig.wechat_auth_domain}/login/#/wx-pc-login?qrcode=${qqqrcodema}&appId=${myOrgConfig.official_account_appid}&uId=${this.org_id}&origin=shanhu`
            }
            console.log('codeUrl==1', this.contractUrl)
            if (this.Weixin && int == 2) {
                console.log
                window.location.href = this.contractUrl
            } else if(!this.Weixin && int == 1) {
                this.$nextTick(() => {
                  this.transQrcode(this.contractUrl)
                })
            }
        },
        transQrcode(item){
          this.qrcode =new QRCode('erweimt',{
                width: 160,
                height:160,
                text: item,  //需要转换的链接
            })
        },
        removeParamFromUrl(paramToRemove) {
            let url = new URL(window.location);
            let searchParams = new URLSearchParams(url.search);
            
            searchParams.delete(paramToRemove);
            url.search = searchParams.toString();
            
            window.history.pushState({}, '', url.toString());
        },
        // 网校学员绑定微信
        bindWechat(fans_id) {
            const data = {
                fans_id: fans_id,
            }
            this.$api.post('/user/index/bindThirdParty', data).then((res) => {
                if (res.data.code === 200) {
                    this.getUserInfo()
                    Toast('绑定成功');
                    this.removeParamFromUrl('code');
                } else {
                    Toast(res.data.message);
                    this.removeParamFromUrl('code');
                    this.getLoginCode(1)
                    if (!this.Weixin) {
                        document.getElementById('erweimt').innerHTML = '';
                    }
                }
            })
        },
        getUserInfo() {
            // 获取用户信息
            const data = {};
            this.$api.post("/user/index/getUserInfo", data).then((res) => {
                if (res.data.code === 200) {
                    this.bind_wechat = res.data.data.bind_wechat
                    this.wechat_header = res.data.data.wechat_header
                    this.wechat_nick = res.data.data.wechat_nick
                    if (!this.bind_wechat && !this.Weixin) {
                        this.getLoginCode(1)
                    } else {
                        clearInterval(this.loginTimer);
                        this.loginTimer = null;
                    }
                }
            });
        },
        goOff () {
            this.$router.replace({
                path: "/my",
                query: {
                    name: 1
                }
            })
        }
      }
    }
    </script>
    <style lang="less" scoped>
    .weixinjs {
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        text-align: left;
        color: #888888;
        margin-top: 10px;
    }
    .qinbdwx {
        font-size: 22px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: Medium;
        color: #202020;
        margin-top: 28px;
    }
    .weixinhz {
        text-align: center;
        position: absolute;
        bottom: 80px;
        left: 50%;
        transform: translate(-50%, -50%);
        .weixintx {
            width: 64px;
            height: 64px;
            margin-bottom: 43px;
        }
        .weixinbdan {
            width: 160px;
        }
    }
    .larweima {
        width: 160px;
        height: 160px;
        margin: 0 auto;
        margin-top: 20px;
    }
    .layout {
        // width: 480px;
        height: 100%;
        margin: auto;
        overflow: hidden;
        text-align: center;
        background: #ffffff;
        margin-top: 40%;
        .qr-code {
            margin-top: 10vh;
        }
        .title {
            font-size: 26px;
        }
        .layout_tx img {
            width: 100px;
            height: 100px;
            border-radius: 50px;
            margin-top: 20px;
        }
        .layout_hb {
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translate(-50%, -50%);
            .layout_butt {
                border: none;
                background: none;
                color: #468ef1;
            }
        }
    }
    </style>